import { initWidget } from '../../utils/Shell';
import ProductEntryWidget from './ProductEntryWidget.vue';

initWidget('ProductEntryWidget', ProductEntryWidget);
